import type { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { Tag as XingTag } from '@xing-com/tag';
import {
  spaceM,
  spaceXXS,
  xdlColorButtonSecondaryHover,
  xdlColorText,
} from '@xing-com/tokens';

export interface IProps {
  children: ReactNode;
  href?: string;
}

const StyledXingTag = styled(XingTag)<{ $isLink: boolean }>`
  display: inline-flex;
  margin-bottom: ${({ $isLink }) => ($isLink ? 0 : spaceM)};
  margin-right: ${({ $isLink }) => ($isLink ? 0 : spaceM)};
  user-select: auto;
  pointer-events: ${({ $isLink }) => ($isLink ? 'auto' : 'none')};
`;

const StyledAnchor = styled.a`
  display: inline-flex;
  color: inherit;
  text-decoration: none;
  margin-bottom: ${spaceM};
  margin-right: ${spaceM};

  &:visited,
  &:hover,
  &:focus,
  &:active {
    color: inherit;
    text-decoration: none;
  }

  &:hover ${StyledXingTag}, &:focus-visible ${StyledXingTag} {
    color: ${xdlColorText};
  }

  &:hover ${StyledXingTag}::after, &:focus-visible ${StyledXingTag}::after {
    background-color: ${xdlColorButtonSecondaryHover};
    border-color: transparent;
    height: calc(100% + ${spaceXXS} * 2);
    inline-size: calc(100% + ${spaceXXS} * 2);
    inset-block-start: -${spaceXXS};
    inset-inline-start: -${spaceXXS};
  }
`;

export const Tag: FC<IProps> = ({ children, href }) => {
  return href ? (
    <StyledAnchor href={href}>
      <StyledXingTag $isLink>{children}</StyledXingTag>
    </StyledAnchor>
  ) : (
    <StyledXingTag $isLink={false}>{children}</StyledXingTag>
  );
};
